import { Link } from "react-router-dom";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./motion-primitives";

const STEPS = [
  {
    no: "01",
    title: "Tell us what you have in mind",
    body: "Your destination, dates, budget and the people travelling with you. Still deciding? Start with what you want from the trip.",
  },
  {
    no: "02",
    title: "Shape the plan together",
    body: "We follow up on your brief, understand your priorities and explore suitable options with our destination partners.",
  },
  {
    no: "03",
    title: "Review your proposal",
    body: "Compare the itinerary, accommodation options, quoted costs and inclusions. Tell us what you would like to adjust.",
  },
  {
    no: "04",
    title: "Proceed when you're ready",
    body: "Once you're happy with the plan, we reconfirm availability and explain the payment and booking conditions before you commit.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="mx-auto max-w-[1400px] px-6 py-16 sm:px-10 lg:px-16 lg:py-20"
    >
      <SectionHeading
        overline="How it works"
        title="From an idea to your holiday."
        testId="how-it-works-heading"
      />

      <div className="mt-12 grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2 lg:mt-14 xl:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal
            key={s.no}
            delay={i * 0.1}
            className="group relative border-t border-charcoal pt-6"
            data-testid={`step-${s.no}`}
          >
            <div className="flex items-baseline gap-5">
              <span className="font-serif text-2xl font-light text-teal">{s.no}</span>
              <span className="h-px flex-1 bg-charcoal transition-colors duration-500 group-hover:bg-teal/50" />
            </div>
            <h3 className="mt-6 font-serif text-xl font-light leading-snug text-cream">{s.title}</h3>
            <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-sand">{s.body}</p>
          </Reveal>
        ))}
      </div>

      <div className="mt-12 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6">
        <Link
          to="/plan-my-trip"
          data-testid="how-it-works-plan-cta"
          className="rounded-none bg-teal px-8 py-4 font-sans text-sm uppercase tracking-[0.18em] text-ink transition-colors hover:bg-cream"
        >
          Plan My Trip
        </Link>
        <p className="font-sans text-sm text-sand">Submitting an enquiry does not confirm a booking.</p>
      </div>
    </section>
  );
};
